import { FC, useMemo } from 'react'
import styles from 'components/features/coaching/advisorMeeting/AdvisorRequestSpinners/AdvisorRequestSpinners.styl'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import { cssVar } from 'helpers/styleHelpers'
import { SEARCH_ADVISOR_DURATION } from 'components/features/coaching/advisorMeeting/types/constants'
import Icon from 'components/atoms/Icon'

export const AdvisorRequestSpinners: FC<{}> = () => {
  const spinnerChild = useMemo(() => (
    <div className={ styles.spinnerIcon }>
      <Spinner size='normal' />
    </div>
  ), [])

  const checkmarkChild = useMemo(() => (
    <div className={ styles.checkmarkIcon }>
      <Icon kind='spinner-success' />
    </div>
  ), [])

  return (
    <div className={ styles.module }>
      <div
        className={ styles.loadingCard }
        style={ cssVar({
          '--duration': `${ SEARCH_ADVISOR_DURATION * .5 }ms`,
        }) }
      >
        <div>
          { checkmarkChild }
          { spinnerChild }
          <span>Checking your matches...</span>
        </div>
        <div>
          { checkmarkChild }
          { spinnerChild }
          <span>Ranking results...</span>
        </div>
        <div>
          { checkmarkChild }
          { spinnerChild }
          <span>Getting time availabilities...</span>
        </div>
      </div>
    </div>
  )
}
